import { ToastrService } from 'ngx-toastr';

import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';

import { FormBaseComponent } from '@bp/shared/components/core';
import { Validators } from '@bp/shared/features/validation';
import { ensureFormGroupConfig } from '@bp/shared/typings';
import { takeUntilDestroyed } from '@bp/shared/models/common';

import type { IChangePasswordApiRequest } from '@bp/admins-shared/domains/identity';

@Component({
	selector: 'bp-change-password-form',
	templateUrl: './change-password-form.component.html',
	styleUrls: [ './change-password-form.component.scss' ],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChangePasswordFormComponent extends FormBaseComponent<IChangePasswordApiRequest> {

	@Input() email?: string;

	override onSubmitShowInvalidInputsToast = false;

	constructor(
		fb: UntypedFormBuilder,
		cdr: ChangeDetectorRef,
		toaster: ToastrService,
	) {
		super(fb, cdr, toaster);

		this.form = this._formBuilder.group(ensureFormGroupConfig<IChangePasswordApiRequest>({
			currentPassword: [ '', [ Validators.required, Validators.password() ]],
			newPassword: [ '', [ Validators.required, Validators.password() ]],
			confirmNewPassword: [ '', [ Validators.required, Validators.confirmPassword('newPassword') ]],
		}));

		this._onNewPasswordChangeRevalidateConfirmNewPassword();
	}

	private _onNewPasswordChangeRevalidateConfirmNewPassword(): void {
		this.controls!.newPassword!.valueChanges
			.pipe(takeUntilDestroyed(this))
			.subscribe(() => void this.controls!.confirmNewPassword!.updateValueAndValidity());
	}
}
